/* Outbound ticket links (TicketFairy, tf.link, Ingresse) → Meta InitiateCheckout + GA4 begin_checkout.
   Adds standard UTMs only when missing. Leaves coupon, promoter, and other params alone. */
(function () {
  var HOSTS = ['ticketfairy.com', 'tf.link', 'ingresse.com'];

  function hostOk(hostname) {
    var h = (hostname || '').toLowerCase();
    for (var i = 0; i < HOSTS.length; i++) {
      if (h === HOSTS[i] || h.slice(-(HOSTS[i].length + 1)) === '.' + HOSTS[i]) return true;
    }
    return false;
  }

  function provider(hostname) {
    return (hostname || '').toLowerCase().indexOf('ingresse') !== -1 ? 'ingresse' : 'ticketfairy';
  }

  function campaign() {
    var path = (window.location.pathname || '').toLowerCase();
    if (path.indexOf('sacbe-ritual') !== -1) return 'regeneration-2026';
    if (path.indexOf('living-altar') !== -1 || path.indexOf('muertos') !== -1) return 'living-altar-2026';
    if (path.indexOf('current-events') !== -1) return 'current-events';
    if (path === '/' || path === '') return 'homepage';
    return path.replace(/^\/pages\//, '').replace(/[^a-z0-9-]+/g, '-').replace(/^-|-$/g, '') || 'sacbe';
  }

  function slug(text) {
    return (text || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 40);
  }

  function decorate(raw, content) {
    var url;
    try {
      url = new URL(raw, window.location.href);
    } catch (e) {
      return null;
    }
    if (!hostOk(url.hostname)) return null;
    var q = url.searchParams;
    if (!q.has('utm_source')) q.set('utm_source', 'sacbe');
    if (!q.has('utm_medium')) q.set('utm_medium', 'website');
    if (!q.has('utm_campaign')) q.set('utm_campaign', campaign());
    if (content && !q.has('utm_content')) q.set('utm_content', content);
    return url.toString();
  }

  var META_PIXEL = '3836198750042223';
  var GA_ID = 'G-CB21BR22DJ';

  function loadScript(src) {
    var s = document.createElement('script');
    s.async = true;
    s.src = src;
    document.head.appendChild(s);
  }

  function armPixels() {
    if (typeof window.fbq !== 'function') {
      var n = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!window._fbq) window._fbq = n;
      window.fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      loadScript('https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', META_PIXEL);
    }
    if (typeof window.gtag !== 'function') {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      loadScript('https://www.googletagmanager.com/gtag/js?id=' + GA_ID);
      window.gtag('js', new Date());
      window.gtag('config', GA_ID, { send_page_view: false });
    }
  }

  function track(url) {
    armPixels();
    var name = document.title || 'SACBE';
    var who = provider(url.hostname);
    var payload = {
      content_name: name,
      content_category: who,
      content_type: 'product',
      num_items: 1
    };
    try {
      window.fbq('track', 'InitiateCheckout', payload);
    } catch (e) {}
    try {
      window.gtag('event', 'begin_checkout', {
        items: [{ item_name: name, item_category: who, item_brand: 'SACBE' }]
      });
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'begin_checkout',
        sacbe_checkout_provider: who,
        ecommerce: { items: [{ item_name: name, item_category: who, item_brand: 'SACBE' }] }
      });
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('sacbe_outbound_checkout', {
          url: url.toString(),
          provider: who,
          content_name: name
        });
      }
    } catch (e) {}
  }

  function arm(a) {
    if (!a || a.dataset.sacbeOutbound === '1') return;
    var href = a.getAttribute('href');
    if (!href) return;
    var next = decorate(href, slug(a.textContent));
    if (!next) return;
    a.dataset.sacbeOutbound = '1';
    if (a.href !== next) a.href = next;
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('a[href]');
    for (var i = 0; i < list.length; i++) arm(list[i]);
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    arm(a);
    try {
      var url = new URL(a.href);
      if (hostOk(url.hostname)) track(url);
    } catch (err) {}
  }, true);

  function boot() {
    armPixels();
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
